import { render } from "./Contact.vue?vue&type=template&id=19efa732&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=19efa732&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19efa732"

export default script